import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  NgZone,
  OnDestroy,
  ViewChild,
} from '@angular/core';

import { DeviceDetectorService } from 'ngx-device-detector';
import { OccasionGeniusService } from 'src/app/core/services/occasion-genius.service';

import { OccasionGeniusEvent } from 'src/app/core/types/models/occasion-genius-event.model';

import Radar from 'radar-sdk-js';
import RadarMap from 'radar-sdk-js/dist/ui/RadarMap';
import RadarMarker from 'radar-sdk-js/dist/ui/RadarMarker';

@Component({
  selector: 'app-occasion-genius-map',
  templateUrl: './occasion-genius-map.component.html',
  styleUrls: ['./occasion-genius-map.component.scss'],
  standalone: true,
  providers: [OccasionGeniusService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OccasionGeniusWithFiltersComponent implements OnDestroy {
  private map: RadarMap;
  private mapMarkers: RadarMarker[] = [];

  @ViewChild('map', { static: true })
  private mapElement: ElementRef<HTMLElement>;

  readonly #deviceDetectorService: DeviceDetectorService = inject(
    DeviceDetectorService,
  );
  readonly #ngZone: NgZone = inject(NgZone);

  @Input({ required: true }) set event(event: OccasionGeniusEvent) {
    if (event.uuid) {
      if (!this.map) {
        this.initMap([Number(event.longitude), Number(event.latitude)]);
      }

      if (this.mapMarkers.length) {
        this.mapMarkers.forEach((marker) => marker.remove());
      }

      const marker: any | RadarMarker = Radar.ui.marker({
        anchor: 'bottom',
      });
      marker
        .setLngLat([Number(event.longitude), Number(event.latitude)])
        .addTo(this.map);
      this.mapMarkers.push(marker);
    }
  }

  ngOnDestroy(): void {
    const userAgent: string = this.#deviceDetectorService.userAgent;
    if (userAgent) {
      if (this.map) {
        this.map.remove();
        this.map = null;
      }
    }
  }

  private initMap(coordinates: [number, number]): void {
    const userAgent: string = this.#deviceDetectorService.userAgent;

    if (userAgent && !this.map) {
      const { nativeElement } = this.mapElement;
      this.#ngZone.runOutsideAngular(() => {
        this.map = Radar.ui.map({
          container: nativeElement,
          style: 'radar-default-v1',
          showZoomControls: false,
          center: coordinates,
          zoom: 16,
          trackResize: true,
        });
      });
    }
  }
}
